import { FC } from 'react'

import cls from './show-more-button.module.scss'

interface ShowMoreButtonProps {
	isActive: boolean
	onClick?: () => void
}

export const ShowMoreButton: FC<ShowMoreButtonProps> = ({ isActive, onClick }) => (
	<button type="button" className={cls.showMoreButton} onClick={() => onClick?.()}>
		{isActive ? `Скрыть` : `Показать еще`}
	</button>
)
